<template>
  <div class="form-group" v-bind:class="{ error: error[0] }">
    <label for="text">Текст заявки</label>
    <textarea
      id="text"
      cols="30"
      rows="2"
      class="form-control"
      placeholder="Введите текст заявки"
      v-bind:value="value"
      v-on:input="updateValue($event.target.value)">
    </textarea>
    <div class="error">{{ error[0] }}</div>
  </div>
</template>

<script>
export default {
  name: 'claim-text-field',
  props: {
    value: String,
    error: Array
  },
  methods: {
    updateValue (value) {
      this.$emit('input', value)
    }
  }
}
</script>


// WEBPACK FOOTER //
// ClaimText.vue?5dba239c